import { useEffect, useState } from 'react'
import { CPF } from 'gerador-validador-cpf'

import PatientsService from 'services/patients'

interface IFieldCPFValidator {
  isCPFValid: boolean
  errorMessageToCPF: string
  errorMessageToAlreadyRegisteredCPF: string
}

const fieldMessages = {
  invalidCPF: 'CPF inválido',
  requiredCPF: 'Campo obrigatório',
  alreadyRegisteredCPF: 'CPF já cadastrado. Entre em contato com nossa equipe pelo chat (no canto inferior direto da tela) para que possamos ajudar.'
}

export const useFieldCPFValidator = (cpf: string): IFieldCPFValidator => {
  const [isCPFValid, setIsCPFValid] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorMessageAlreadyRegisteredCPF, setErrorMessageAlreadyRegisteredCPF] = useState('')

  useEffect(() => {
    if (cpf === null || cpf === '') {
      setIsCPFValid(false)  
      setErrorMessage('')
      setErrorMessageAlreadyRegisteredCPF('')
      return
    }

    const isValid = CPF.validate(cpf) //eslint-disable-line
    const formattedCpf = CPF.format(cpf, 'digits') //eslint-disable-line
    
    if (!cpf) {
      setIsCPFValid(false)
      setErrorMessage(fieldMessages.requiredCPF)
    }

    if (!isValid) {
      setIsCPFValid(false)
      setErrorMessage(fieldMessages.invalidCPF)
      setErrorMessageAlreadyRegisteredCPF('')
    } else {
      setErrorMessage('')
      PatientsService.isCpfAvailable(formattedCpf)
        .then(() => {
          setIsCPFValid(false)   
          setErrorMessageAlreadyRegisteredCPF(fieldMessages.alreadyRegisteredCPF)
        })
        .catch(() => {
          setIsCPFValid(true)
          setErrorMessageAlreadyRegisteredCPF('')
        })
    }
  }, [cpf])

  return {
    isCPFValid,
    errorMessageToCPF: errorMessage,
    errorMessageToAlreadyRegisteredCPF: errorMessageAlreadyRegisteredCPF
  }
}